import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PatientService, UserService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-recoverycoach',
  templateUrl: './recoverycoach.component.html',
  styleUrls: ['../style.component.css', './recoverycoach.component.css']
})
export class RecoverycoachComponent implements OnInit {
  patid: any;
  welcome: any;
  modalRef: any;
  resdata: any;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    private patientservice: PatientService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private nav: Router,
    private userService: UserService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(userService.defaultLang);
   }

  ngOnInit() {
    this.routerr.params.subscribe(params => {
      this.patid = params
      this.patientservice.changeNav(params['id'])
      this.patid = params['id']
      ////////console.log(this.patid);
    });
  }
  // addpat(result){

  //   this.patientservice
  //   .getwelcome(this.patid)
  //   .subscribe(
  //     data => 
  //     {


  //       if(data.userInfo.status == "success") {

  //       this.nav.navigate([`/createnewpass/${this.patid}`])
  //        } 
  //        else{
  //         this.resdata = "You have already registered";
  //         this.modalRef = this.modalService.show(result, {class: 'modal-sm'});

  //        }
  //     }      
  //   );

  // }
}
